// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorFallbackComponent_container__T6RoC","imageContainer":"ErrorFallbackComponent_imageContainer__3glFP","title":"ErrorFallbackComponent_title__3Unsk"};